import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 24px',
      textAlign: 'center',
      background: '#F9F9F9',
    }}>
      <div style={{
        fontSize: '120px',
        fontWeight: '800',
        color: '#282C68',
        lineHeight: 1,
        marginBottom: '8px',
      }}>
        404
      </div>
      <div style={{
        width: '60px',
        height: '4px',
        background: 'linear-gradient(90deg, #282C68, #40B6BF)',
        borderRadius: '2px',
        marginBottom: '24px',
      }} />
      <div style={{
        fontSize: '24px',
        fontWeight: '700',
        color: '#282C68',
        marginBottom: '12px',
      }}>
        Page Not Found
      </div>
      <div style={{
        fontSize: '15px',
        color: '#777',
        maxWidth: '440px',
        lineHeight: '1.7',
        marginBottom: '36px',
      }}>
        The page you're looking for doesn't exist or has been moved. Let's get you back on track.
      </div>
      <Link to='/' style={{
        padding: '14px 40px',
        background: '#282C68',
        color: '#fff',
        fontWeight: '700',
        fontSize: '14px',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        borderRadius: '50px',
        textDecoration: 'none',
        transition: 'all 0.3s ease',
      }}>
        Back to Home
      </Link>
    </div>
  );
}
